<template>
  <TMainForm :script-id="scriptId" :interception="interception" :buttons="buttons" :default-design="defaultDesign"
    :default-change-script="defaultChangeScript" :default-proccess-script="defaultProccessScript" />
</template>

<script setup>
/**
 * TTMGMPumpStationForm
 */
import TMainForm from './TMainForm.vue';

const props = defineProps({
  scriptId: { type: Number, default: null },
  interception: { type: [String, Object, Boolean], default: null },
});

const buttons = [];
const defaultDesign = null;
const defaultChangeScript = null;
const defaultProccessScript = null;
</script>
